// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3snIU","controls":"styles_controls__3xwRB","charLimit":"styles_charLimit__39q_p","input":"styles_input__1shqm","send":"styles_send__14Tyv"};